import request from '@/utils/request'
const qs = require('qs')
export function listDataMasterProduk(data) {
  return request({
    url: '/master_produk/list_data_master_produk',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportMasterProduk.js